import api from '../services/api';

// Extensões e tamanho aceitos para o contrato (o servidor confere de novo).
export const EXTENSOES_CONTRATO = ['.pdf', '.doc', '.docx', '.jpg', '.jpeg', '.png'];
export const TAMANHO_MAX_CONTRATO_MB = 20;

// Devolve o texto do erro se o arquivo não serve; null se está tudo certo.
export const validarArquivoContrato = (arquivo) => {
  if (!arquivo) return null;
  const nome = arquivo.name.toLowerCase();
  if (!EXTENSOES_CONTRATO.some((ext) => nome.endsWith(ext))) {
    return 'Anexe o contrato em PDF, Word (doc/docx) ou imagem (jpg/png).';
  }
  if (arquivo.size === 0) return 'O arquivo escolhido está vazio.';
  if (arquivo.size > TAMANHO_MAX_CONTRATO_MB * 1024 * 1024) return `O arquivo deve ter no máximo ${TAMANHO_MAX_CONTRATO_MB} MB.`;
  return null;
};

const mensagemDoErro = async (err) => {
  // Quando pedimos um arquivo (blob) e o servidor responde erro, a mensagem também vem como blob.
  try {
    const dados = err?.response?.data;
    if (dados instanceof Blob) {
      const texto = JSON.parse(await dados.text());
      return texto.detail || 'Não foi possível abrir o contrato.';
    }
    return dados?.detail || 'Não foi possível abrir o contrato.';
  } catch {
    return 'Não foi possível abrir o contrato.';
  }
};

// O contrato passa pelo servidor com o login do usuário (não existe link público).
export const abrirContrato = async (projeto) => {
  const nome = projeto.contrato_nome || `contrato-${projeto.id}`;
  const previa = /\.(pdf|png|jpe?g)$/i.test(nome);
  // A aba precisa ser aberta já no clique, antes da espera, senão o navegador bloqueia.
  const janela = previa ? window.open('', '_blank') : null;
  try {
    const res = await api.get(`/projetos/${projeto.id}/contrato/`, { responseType: 'blob' });
    const url = URL.createObjectURL(res.data);
    if (janela) {
      janela.location.href = url;
    } else {
      const link = document.createElement('a');
      link.href = url;
      link.download = nome;
      document.body.appendChild(link);
      link.click();
      link.remove();
    }
    setTimeout(() => URL.revokeObjectURL(url), 120000);
  } catch (err) {
    if (janela) janela.close();
    throw new Error(await mensagemDoErro(err));
  }
};
